import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Khung xám nhấp nháy trong lúc chờ dữ liệu. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('skeleton rounded-none', className)} />
}

/** Trạng thái rỗng: không có kết quả, chưa có tin đăng… */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
}) {
  return (
    <div
      data-upbo-type="container"
      className={cn('flex flex-col items-center text-center gap-3 py-14 px-6', className)}
    >
      {icon && <div className="h-14 w-14 grid place-items-center rounded-squircle border border-border text-text-muted">{icon}</div>}
      <h3 className="text-2xl">{title}</h3>
      {description && <p className="max-w-md text-sm text-text-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}

/** Dải sao đánh giá. */
export function Rating({ value, count, size = 14 }: { value: number; count?: number; size?: number }) {
  const rounded = Math.round(value * 2) / 2
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-flex" aria-label={`${value}/5`}>
        {[1, 2, 3, 4, 5].map((i) => (
          <svg key={i} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
            className={i <= rounded ? 'text-warning' : 'text-border-strong'}
            fill="currentColor">
            <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        ))}
      </span>
      <span className="text-xs font-semibold text-text-muted">
        {value.toFixed(1)}
        {typeof count === 'number' && count > 0 ? ` (${count})` : ''}
      </span>
    </span>
  )
}
